module.exports = __webpack_public_path__ + "img/UTJORD-8.07431fc7.jpg";